<template>
  <ValidationObserver ref="observe">
    <b-form>
      <ek-dialog
        ref="addDialog"
        title="اضافة مستخدم"
        @delete="delUser(userDto.id)"
        placeholder="ابحث عن مستخدم محدد"
        btnText="اضافة مستخدم"
        @ok="submit()"
        @close="reset"
        @search="setSearch"
      >
        <template #body>
          <ek-input-text
            :rules="[{ type: 'required', message: ' اسمالمستخدم  مطلوب' }]"
            name="name"
            placeholder="أدخل اسم المستخدم   "
            label=" اسم المستخدم"
            v-model="userDto.userName"
          ></ek-input-text>
          <ek-input-text
            :rules="[{ type: 'required', message: 'الاسم و الكنية مطلوب' }]"
            name="name"
            placeholder="أدخل الاسم و الكنية "
            label="الاسم و الكنية"
            v-model="userDto.name"
          ></ek-input-text>

          <ek-input-text
            :rules="[
              { type: 'email', message: 'يرجى ادخال بريد الكتروني صحيح' },
            ]"
            name="email"
            placeholder="ادخل البريد الالكتروني"
            label="البريد الالكتروني"
            v-model="userDto.email"
          ></ek-input-text>

          <ek-input-text
            :rules="[
              { type: 'required', message: 'كلمة المرور مطلوبة' },
              {
                type: 'min:8',
                message: 'كلمة المرور يجب ان تحوي 8 محارف على الاقل',
              },
            ]"
            name="password"
            placeholder="أدخل  كلمة السر"
            label="كلمة السر"
            v-model="userDto.password"
          ></ek-input-text>

          <ek-input-text
            :rules="[
              { type: 'required', message: 'رقم الموبايل مطلوب' },
              { type: 'mobile', message: 'رقم الموبايل غير صالح' },
            ]"
            name="phoneNumber"
            placeholder="أدخل رقم الموبايل"
            label="رقم الموبايل"
            v-model="userDto.phoneNumber"
          ></ek-input-text>
        </template>
      </ek-dialog>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    ValidationObserver,
  },
  computed: {
    ...mapState({
      userDto: (state) => state.user.userDto,
    }),
  },
  methods: {
    ...mapActions(["addUser", "deleteUser"]),
    submit() {
      this.$refs.observe.validate().then((success) => {
        if (success) {
          this.addUser({
            userName: this.userDto.userName,
            name: this.userDto.name,
            email: this.userDto.email,
            password: this.userDto.password,
            phoneNumber: this.userDto.phoneNumber,
          });
          this.$refs.addDialog.close();
          this.$refs.observe.reset();
        }
      });
    },
    delUser(id) {
      this.deleteUser(id);
      this.$refs.dialog.close();
    },
    reset() {
      this.$refs.observe.reset();
      Object.assign(this.userDto, {
        name: "",
        email: "",
        userName: "",
        password: "",
        phoneNumber: "",
      });
    },
    setSearch(query) {
      this.$store.commit("Set_Search_Dto", {
        keys: ["name", "userName", "email", "phoneNumber"],
        query,
      });
    },
    open() {
      this.$refs.addDialog.open();
    },
  },
};
</script>
